import { translationBaseKey } from '../../../decorators/translation-base-key.decorator';
import { ValidateNested } from '@pristine-ts/class-validator';
import { type } from '@pristine-ts/data-mapping-common';
import { IncomeTaxPersonalOptions } from '../../calculations/income-tax/personal/personal/income-tax-personal.options';
import {
  SalaryContributionsOptionsInSalaryDividendOptions,
} from '../../calculations/salary-dividend/salary-contributions/salary-contributions-options-in-salary-dividend.options';
import {
  QppPensionOptionsInSalaryDividendOptions,
} from '../../calculations/salary-dividend/qpp-pension/qpp-pension-options-in-salary-dividend.options';
import { SalaryDividendOptions } from '../../calculations/salary-dividend/salary-dividend.options';
import { ClientQuestionnaireOptions } from '../client-questionnaire.options';
import { ClientQuestionnaireKeynameEnum } from '../../../enums/client-questionnaire/client-questionnaire-keyname.enum';
import { clonePropertyMetadata } from '@pristine-ts/metadata';
import {
  CorporateIncomeTaxInSalaryDividendOptions,
} from '../../calculations/salary-dividend/income-tax/corporate/corporate-income-tax-in-salary-dividend.options';
import {advancedFormGroup} from "@magieno/common";

@translationBaseKey('salary-dividend-tax-questionnaire-options')
export class SalaryDividendTaxQuestionnaireOptions extends ClientQuestionnaireOptions {
  keyname = ClientQuestionnaireKeynameEnum.SalaryDividend;

  @clonePropertyMetadata<SalaryDividendOptions>(SalaryDividendOptions, 'isEligibleDividendMaximized')
  isEligibleDividendMaximized: boolean = true;

  @clonePropertyMetadata<SalaryDividendOptions>(SalaryDividendOptions, 'isQppPensionCalculated')
  isQppPensionCalculated: boolean = true;

  @clonePropertyMetadata<SalaryDividendOptions>(SalaryDividendOptions, 'isShareHolderSubjectToEI')
  isShareHolderSubjectToEI: boolean;

  @clonePropertyMetadata<SalaryDividendOptions>(SalaryDividendOptions, 'costOfLiving')
  costOfLiving: number;

  @clonePropertyMetadata<QppPensionOptionsInSalaryDividendOptions>(QppPensionOptionsInSalaryDividendOptions, 'deathAge')
  deathAge: number = 85;

  @clonePropertyMetadata<IncomeTaxPersonalOptions>(IncomeTaxPersonalOptions, 'isMarried')
  isMarried: boolean;

  @type(() => new IncomeTaxPersonalOptions())
  @advancedFormGroup({
    classType: IncomeTaxPersonalOptions,
  })
  @ValidateNested()
  incomeTaxPersonalOptions: IncomeTaxPersonalOptions;

  @type(() => new SalaryContributionsOptionsInSalaryDividendOptions())
  @advancedFormGroup({
    classType: SalaryContributionsOptionsInSalaryDividendOptions,
  })
  @ValidateNested()
  salaryContributionsOptions: SalaryContributionsOptionsInSalaryDividendOptions;

  @type(() => new CorporateIncomeTaxInSalaryDividendOptions())
  @advancedFormGroup({
    classType: CorporateIncomeTaxInSalaryDividendOptions,
  })
  @ValidateNested()
  corporateIncomeTaxOptions: CorporateIncomeTaxInSalaryDividendOptions;
}